import { render, staticRenderFns } from "./GalleryViewSkeletonLoader.vue?vue&type=template&id=1ed34d21&scoped=true"
import script from "./GalleryViewSkeletonLoader.vue?vue&type=script&lang=ts"
export * from "./GalleryViewSkeletonLoader.vue?vue&type=script&lang=ts"
import style0 from "./GalleryViewSkeletonLoader.vue?vue&type=style&index=0&id=1ed34d21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed34d21",
  null
  
)

export default component.exports